import { Grid } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { styled } from "@mui/material/styles";

export const ButtonsContainer = styled(Grid)(() => ({
  paddingTop: "24px",
  paddingBottom: "24px",
}));

const styles = makeStyles(() => ({
  preferencesWrapper: {
    padding: "24px",
    border: "1px solid #E4E7EC",
    borderRadius: 8,
  },
  section: {
    marginTop: 20,
  },
  sectionTitle: {
    marginBottom: 20,
    color: "#465869",
    fontSize: 16,
    fontFamily: "'Manrope', sans-serif",
    lineHeight: "18px",
    fontWeight: "bold",
  },
}));

export default styles;
